<div class="body-partnerships">
  <div class="d-flex padding-title">
    <ng-container *ngIf="hasPack">
      <a [routerLink]="path" (click)="close()">
        <div class="partnerships-title">{{'pt.edp.edponline.benefits.partnerships.title' | translate}}
          <span class="d-inline-block icon mx-2 icon_margin">
            <i class="icon-edponline-Bop-073 rotate-270 icon-size"  aria-hidden="true"></i>
          </span>
        </div>
      </a>
    </ng-container>
    <ng-container *ngIf="!hasPack">
      <a href="{{ 'pt.edp.edponline.pack.leisure.knowmore.generic' | translate}}"
        [edpExternalLink]="'pt.edp.edponline.pack.leisure.knowmore.generic' | translate">
        <div class="partnerships-title">{{'pt.edp.edponline.benefits.partnerships.credit.title' | translate}}
          <span class="d-inline-block icon mx-2 icon_margin">
            <i class="icon-edponline-EDP_Online_09 icon-size"  aria-hidden="true"></i>
          </span>
        </div>
      </a>
    </ng-container>
  </div>
  <div class="d-flex justify-content-around padding-cards">
    <span class="column d-block pr-2 pl-0" *ngFor="let item of partnerships">
      <div class="card">
        <div class="card-body">
          <div class="partnerships-card-title">{{item.name | uppercase}}</div>
          <div class="partnerships-description mt-2">{{ item.description}}</div>
          <div class="icon-div">
            <a [routerLink]="path" (click)="close()" *ngIf="hasPack">
              <span class="icon">
                <i class="icon-edponline-Bop-073 rotate-270 icon-size"  aria-hidden="true"></i>
              </span>
            </a>
            <a [href]="(item.partnerName | translate)" *ngIf="!hasPack"
              [edpExternalLink]="item.partnerName | translate">
              <span class="icon">
                <i class="icon-edponline-EDP_Online_09 icon-size"  aria-hidden="true"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </span>
  </div>
</div>
